import { ProfileMenu } from "../Menu/ProfileMenu";
import { TrackMenu } from "../Menu/TrackMenu";
import { useMenuItems } from "../../../services/api-client/useMenuItems";
import SimpleButton from "../Input/SimpleButton";
import { Add } from "../Icons/Interface";
import { BrandName } from "./BrandName";

export function AppNavBar({ children }: { children?: React.ReactNode }) {
	const menuSource = useMenuItems();
	return (
		<nav>
			<div className="flex justify-between items-start">
				<BrandName theme="dark" navigateTo="/dashboard" />
				<div className="space-x-4">
					{menuSource.trackActions.length > 1 ? (
						//Many items therefore, make a menu
						<TrackMenu
							actionList={menuSource.trackActions}
							badgeClass="h-8 border-primary-accent hover:border-primary-active active:border-primary-active border text-primary rounded-full px-4"
						/>
					) : (
						//There is only one Track item ... might as well make this a button not a menu
						<div className="realitive inline-block">
							<SimpleButton
								onClick={() => menuSource.trackActions[0].actionFunc(() => {})}
								className="h-8 border-primary-accent hover:border-primary-active active:border-primary-active border text-primary rounded-full px-4"
							>
								<div>{Add()}</div>
								<p>Track</p>
							</SimpleButton>
						</div>
					)}
					<ProfileMenu
						actionList={menuSource.profileActions}
						badgeClass="h-8 border-primary-accent hover:border-primary-active active:border-primary-active border text-primary rounded-full"
					/>
				</div>
			</div>
		</nav>
	);
}
